import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import HighlightText from "../components/core/HomePage/HighlightText";
import CTAButton from "../components/core/HomePage/Button";
import Banner from "../assets/Images/banner.mp4";
import CodeBlocks from "../components/core/HomePage/CodeBlocks";
import Footer from "../components/common/Footer";
import TimelineSection from "../components/core/HomePage/TimelineSection";
import LearningLanguageSection from "../components/core/HomePage/LearningLanguageSection";
import InstructorSection from "../components/core/HomePage/InstructorSection";
import ExploreMode from "../components/core/HomePage/ExploreMode";
import ReviewSlider from "../components/common/ReviewSlider";

function Home(props) {
  return (
    <div>
      {/* Section 1 */}
      <div
        className="relative mx-auto flex flex-col w-11/12 max-w-maxContent items-center 
                    text-white justify-between">
        <div className=" group mt-16 p-1 mx-auto rounded-full bg-richblack-800 font-bold text-richblack-200 transition-all duration-200 hover:scale-95 w-fit">
          <Link to={"/signup"}>
            <div className="flex flex-row items-center gap-2 rounded-full px-10 py-[5px] transition-all duration-200 group-hover:bg-richblack-900 ">
              <p>Become an Instructor</p>
              <FaArrowRight />
            </div>
          </Link>
        </div>

        <div className="text-center font-semibold text-4xl mt-4">
          Empower Your Future with
          <HighlightText text={"Coding Skills"} />
        </div>

        <div className="w-[90%] text-center text-md font-bold text-richblack-300 mt-4">
          With our online coding courses, you can learn at your own pace, from
          anywhere in the world, and get access to a wealth of resources,
          including hands-on projects, quizzes, and personalized feedback from
          instructors.
        </div>

        <div className="flex flex-row gap-7 mt-8">
          <CTAButton active={true} linkto={"/signup"}>
            Learn More
          </CTAButton>
          <CTAButton active={false} linkto={"/signup"}>
            Book a Demo
          </CTAButton>
        </div>

        <div className="mx-3 my-12 shadow-2xl shadow-blue-500/40 ">
          <video
            muted
            loop
            autoPlay
            className="inset-20 bg-indigo-500 max-[450px]:shadow-[rgba(245,245,245,1)_15px_15px_0px_0px] shadow-[rgba(245,245,245,1)_25px_25px_0px_0px]">
            {" "}
            <source src={Banner} type="video/mp4" />
          </video>
        </div>

        {/* Code Section 1 */}
        <div>
          <CodeBlocks
            position={"lg:flex-row flex-col"}
            heading={
              <div className="text-4xl font-semibold">
                Unlock your <HighlightText text={"coding potential"} /> with our
                online courses.
              </div>
            }
            subheading={
              "Our courses are designed and taught by industry experts who have years of experience in coding and are passionate about sharing their knowledge with you."
            }
            ctabtn1={{
              btnText: "Try it yourself",
              linkto: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn more",
              linkto: "/login",
              active: false,
            }}
            codeblock={
              '<!DOCTYPE html>\n<html>\nhead><title>Example</title><linkrel="stylesheet"href="styles.css">\n/head>\nbody>\nh1><ahref="/">Header</a>\n/h1>\nnav><ahref="one/">One</a><ahref="two/">Two</a><ahref="three/">Three</a>\n/nav>'
            }
            codeColor={
              "bg-gradient-to-b from-[#A6FFCB] text-transparent via-[#12D8FA] to-[#1FA2FF] bg-clip-text"
            }
            backgroundGradient={<div className="codeblock1 absolute"></div>}
          />
        </div>

        {/* Code Section 2 */}
        <div>
          <CodeBlocks
            position={"md:flex-row-reverse flex-col"}
            heading={
              <div className="text-4xl font-semibold">
                Start <HighlightText text={"coding in seconds"} />
              </div>
            }
            subheading={
              "Go ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."
            }
            ctabtn1={{
              btnText: "Continute Lesson",
              linkto: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn more",
              linkto: "/login",
              active: false,
            }}
            codeblock={
              '<!DOCTYPE html>\n<html>\nhead><title>Example</title><linkrel="stylesheet"href="styles.css">\n/head>\nbody>\nh1><ahref="/">Header</a>\n/h1>\nnav><ahref="one/">One</a><ahref="two/">Two</a><ahref="three/">Three</a>\n/nav>'
            }
            codeColor={
              "bg-gradient-to-b from-[#1FA2FF] text-transparent via-[#12D8FA] to-[#A6FFCB] bg-clip-text"
            }
            backgroundGradient={<div className="codeblock2 absolute"></div>}
          />
        </div>

        <ExploreMode />
      </div>
      {/* Section 1 */}

      {/* Section 2 */}
      <div className="bg-pure-greys-5 text-richblack-700">
        <div className="homepage_bg h-[320px]">
          <div className="w-11/12 max-w-maxContent flex justify-center items-center gap-5 mx-auto h-[100%]">
            {/* <div className="h-[7rem]"></div> */}
            <div className="flex gap-7 text-white mt-16">
              <CTAButton active={true} linkto={"/signup"}>
                <div className="flex gap-x-2 items-center">
                  Explore Full Catalog
                  <FaArrowRight />
                </div>
              </CTAButton>

              <CTAButton active={false} linkto={"/signup"}>
                Learn More
              </CTAButton>
            </div>
          </div>
        </div>
        <div className="w-11/12 mx-auto max-w-maxContent flex flex-col items-center justify-between gap-7">
          <div className="flex lg:flex-row flex-col gap-5 mt-[120px] mb-[80px] justify-center">
            <div className="text-4xl font-semibold lg:w-[45%] ">
              Get the skills you need for a{" "}
              <HighlightText text={"job that is in demand."} />
            </div>
            <div className="flex flex-col gap-10 lg:w-[40%] items-start">
              <div className="text-[16px]">
                The modern StudyNotion is the dictates its own terms. Today, to
                be a competitive specialist requires more than professional
                skills.
              </div>
              <div className="">
                <CTAButton active={true} linkto={"/signup"}>
                  <div>Learn More</div>
                </CTAButton>
              </div>
            </div>
          </div>

          <TimelineSection />

          <LearningLanguageSection />
        </div>
      </div>
      {/* Section 2 */}

      {/* Section 3 */}
      <div className="w-11/12 mx-auto  max-w-maxContent flex flex-col items-center justify-between gap-7 bg-richblack-900 text-white">
        <InstructorSection />
        <h2 className="text-center max-[450px]:hidden text-4xl font-semibold mt-10">
          Reviews from other learners
        </h2>
        {/* review slider */}
        <ReviewSlider/>
      </div>
      {/* Section 3 */}

      {/* Footer */}
      <div>
        <Footer />
      </div>
      {/* Footer */}
    </div>
  );
}

export default Home;